import React, { useState, useEffect, useMemo, useCallback } from "react";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import DownloadIcon from "@material-ui/icons/Download";
import PaidIcon from "@material-ui/icons/Paid";
import CancelIcon from "@material-ui/icons/Cancel";
import * as locales from "@material-ui/core/locale";
// material
import {
  Button,
  Card,
  Container,
  Grid,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Chip,
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { TablaHead, TablaToolbar } from "../../_dashboard/tablas";
import Label from "../../Label";
import Scrollbar from "../../Scrollbar";
import SearchNotFound from "../../SearchNotFound";
import ModalChangeState from "../ModalChangeState";
import ModalForm from "../ModalForm";
import PagosFacturaPlanesDialog from "./PagosFacturaPlanesDialog";
import {
  actualizarFolioFactura,
  actualizarFolioFacturaTarea,
} from "../consultasFacturas";
import ModalVerFactura from "../ModalVerFactura";
import { Alerta } from "src/components/Alerta";
import { LocalizationProvider } from "@material-ui/lab";
import AdapterDateFns from "@material-ui/lab/AdapterDateFns";
import { es } from "date-fns/locale";
import { useSelector } from "react-redux";
import moment from "moment";
import { useSnackbar } from "src/components/snackbar";
import { facturasApi } from "src/services/facturasApi";
import { AlertaModalV2 } from "src/components/AlertaSwall";
import AutoCompleteField from "src/components/Modal/sharedFields/AutocompleteField";
import { useFormik } from "formik";
import * as Yup from "yup";
import { sucursalesApi } from "src/services/sucursalesApi";
import ExportarAExcel from "src/components/exportarExcelLiquidacion/ExportarExcelLiquidacion";
import handleError from "src/utils/manejo-errores.js";
import { formatAsCLP } from "src/utils/formatNumber";
import ExcelJS from "exceljs";
import {
  activarCalculoAutomatico,
  aplicarBordeUltimaFila,
  guardarArchivo,
} from "src/utils/excel-plantillas.js";
import dayjs from "dayjs";
import "dayjs/locale/es.js";
import { RutFormat, formatRut } from "@fdograph/rut-utilities";
import {
  ajustarFecha,
  calcularDiasRetraso,
  formatearFecha,
} from "src/utils/formatTime";
import Iconify from "src/components/iconify";
import checkCircleOutlined from "@iconify/icons-ant-design/check-circle-outlined";
import warningOutlined from "@iconify/icons-ant-design/warning-outlined";
import {
  capitalizarPrimeraLetra,
  decodeHtmlEntities,
  descargarPDFDesdeBase64,
  descargarPdfDteProxy,
} from "src/utils/sharedFunctions";
import { useDescargarPdfDteMutation } from "src/services/dteApi";
import TipoDocumentoChip from "../TipoDocumentoChip";
import { nombreArchivoDte, tipoProxyDesdeFactura } from "../documentoDte";
import CustomTablePagination from "src/components/CustomTablePagination";
import { SwapHoriz, AttachMoney as AttachMoneyIcon } from "@material-ui/icons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ModalCambioSucursal from "src/components/Modal/modalCambioSucursal";
import ModalAnularFactura from "src/components/Modal/modalAnularFactura";
import ModalCorregirMonto from "src/components/Modal/modalCorregirMonto";
import { APP_CONFIG } from "src/config/appConfig";
import { useCuadrarFacturaMutation } from "src/services/pagosApi";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
dayjs.locale("es");

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// Tipos que aceptan corrección de monto. Espeja el `enum` de los dos endpoints
// (`/:id/:tipo/abonos` y `/:id/:tipo/corregir-monto`, ambos `["PLAN","TAREA"]`). El listado
// es un union de tres familias y las filas de facturaAfecta llegan con `tipo: "AFECTA"`, que
// el backend rechaza con 400: sin este filtro el menú ofrece una acción que no puede
// completarse.
const TIPOS_CORREGIBLES = ["PLAN", "TAREA"];

const TABLE_HEAD = [
  { id: "rut", label: "RUT", alignRight: false },
  { id: "nombre", label: "Cliente", alignRight: false },
  { id: "telefono", label: "Teléfono", alignRight: false },
  { id: "folio", label: "Folio", alignRight: false },
  { id: "documento", label: "Documento", alignRight: false },
  { id: "detalleFactura", label: "Glosa", alignRight: false },
  { id: "valorPesos", label: "Total ($)", alignRight: false },
  { id: "periodo", label: "Periodo", alignRight: false },
  { id: "fechaFacturacion", label: "Fecha Facturación", alignRight: false },
  { id: "fechaCorreo", label: "Fecha Envio Correo", alignRight: false },
  { id: "estadoCorreo", label: "Estado Correo", alignRight: false },
  { id: "estadoFactura", label: "Estado Facturación", alignRight: false },
  { id: "fechaPago", label: "Fecha Pago", alignRight: false },
  { id: "tipo", label: "Tipo Factura", alignRight: false },
  { id: "sucursal", label: "Sucursal", alignRight: false },
  { id: "retraso", label: "Retraso pago", alignRight: false },
  { id: "" },
];

const INITIAL_STATE_TABLE = {
  currentPage: 0,
  rowsPerPageOptions: 10,
  order: "desc",
  orderBy: "fechaFacturacion",
  locale: "esES",
  filterName: "",
};

export default function FacturaPlanes({ tabIndex }) {
  const {
    empleado: user,
    sucursal: sucursalObtenida,
    rol: rolObtenido,
  } = useSelector((state) => state.auth.user);
  const { enqueueSnackbar } = useSnackbar();

  const [mostrarPagoFactura, setMostrarPagoFactura] = useState(false);
  const [statesTable, setStateTable] = useState(INITIAL_STATE_TABLE);
  const newDate = useMemo(() => new Date(), []);
  const [mesActual, setMesActual] = useState(newDate.getMonth());
  const [anioActual, setAnioActual] = useState(newDate.getFullYear());

  const [mesActual2, setMesActual2] = useState(newDate.getMonth());
  const [anioActual2, setAnioActual2] = useState(newDate.getFullYear());

  const [anios, setAnios] = useState([]);

  const [loadingDescargar, setLoadingDescargar] = useState(false);

  const [descargarPdfDte] = useDescargarPdfDteMutation();
  const [anularFactura, { isLoading: isLoadingAnular }] =
    facturasApi.useAnularFacturaMutation();
  const [corregirMonto, { isLoading: isLoadingCorregir }] =
    facturasApi.useCorregirMontoFacturaMutation();

  const {
    data: sucursalesEmpleado = [],
    isLoading: isLoadingSucursalesEmpleado,
  } = sucursalesApi.useGetSucursalesEmpleadosQuery(user.rut);

  const opcionesFiltro = !isLoadingSucursalesEmpleado
    ? [
        { id: 0, nombre: "TODAS", label: "Todas las sucursales" },
        ...sucursalesEmpleado.map((sucursal) => {
          const obj = {
            id: sucursal.refSucursal,
            nombre: sucursal.refSucursal,
            label: sucursal.label,
          };
          return obj;
        }),
      ]
    : [];

  const facturaPlanesSchema = Yup.object().shape({
    filtro: Yup.object()
      .shape({
        id: Yup.number().required(),
        nombre: Yup.string().required(),
      })
      .required("La sucursal es requerida"),
  });

  const formik = useFormik({
    initialValues: {
      filtro: { id: 0, nombre: "TODAS", label: "Todas las sucursales" },
      incluyeRemuneraciones: false,
    },
    validationSchema: facturaPlanesSchema,
  });

  const { values, touched, errors, setFieldValue } = formik;

  const [exportarFacturasExcel] =
    facturasApi.useLazyGetFacturasTotalExportarQuery();
  const [loadingExport, setLoadingExport] = useState(false);

  const {
    data: facturas = { results: [], total: 0 },
    isLoading: loadingTable,
    refetch: recargarFacturas,
    isFetching: isFetchingSucursales,
  } = facturasApi.useGetFacturasPorSucursalQuery({
    sucursales:
      rolObtenido === "SUPER_ADMIN" || rolObtenido === "ADMIN"
        ? values.filtro.nombre === "TODAS" //Si selecciona todas las sucursales en el select, se pasan las sucursales del empleado para filtrar
          ? sucursalesEmpleado
          : values.filtro.nombre
        : sucursalObtenida,
    page: statesTable.currentPage,
    perPage: statesTable.rowsPerPageOptions,
    mesInicio: mesActual + 1 <= 9 ? `0${mesActual + 1}` : mesActual + 1,
    anioInicio: anioActual,
    mesFin: mesActual2 + 1 <= 9 ? `0${mesActual2 + 1}` : mesActual2 + 1,
    anioFin: anioActual2,
    search: statesTable.filterName,
  });

  const [modalCambioSucursal, setModalCambioSucursal] = useState(false);
  const [datosCambioSucursal, setDatosCambioSucursal] = useState(null);

  const [modalAnularFactura, setModalAnularFactura] = useState(false);
  const [facturaAAnular, setFacturaAAnular] = useState(null);
  const [modalCorregirMonto, setModalCorregirMonto] = useState(false);
  const [facturaACorregir, setFacturaACorregir] = useState(null);

  const [cuadrarFactura, { isLoading: isLoadingCuadre }] =
    useCuadrarFacturaMutation();

  // Estado para menú de acciones
  const [anchorEl, setAnchorEl] = useState(null);
  const [facturaMenuSeleccionada, setFacturaMenuSeleccionada] = useState(null);

  const [actualizarEstadoFacturaPlanes] =
    facturasApi.useUpdateEstadoFacturaPlanMutation();
  const [actualizarEstadoCorreoPlanes] =
    facturasApi.useUpdateEstadoCorreFacturaPlanesMutation();

  const [actualizarEstadoFacturaTareas] =
    facturasApi.useUpdateEstadoFacturaTareaMutation();
  const [actualizarEstadoCorreoTareas] =
    facturasApi.useUpdateEstadoCorreFacturaTareasMutation();

  const [actualizarEstadoFacturaAfecta] =
    facturasApi.useUpdateEstadoFacturaAfectaMutation();
  const [actualizarEstadoCorreoAfecta] =
    facturasApi.useUpdateEstadoCorreFacturaAfectaMutation();

  useEffect(() => {
    let arregloAnios = [];
    for (let index = newDate.getFullYear(); index >= 2020; index--) {
      arregloAnios.push(index);
    }
    setAnios(arregloAnios);
  }, [newDate]);

  function formatNumber(n) {
    n = n > 0 ? String(n).replace(/\D/g, "") : n;

    return n === "" ? n : Number(n).toLocaleString("es-CL");
  }

  const handleChangePage = (event, newPage) => {
    setStateTable({ ...statesTable, currentPage: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setStateTable({
      ...statesTable,
      rowsPerPageOptions: Number(event.target.value),
      currentPage: 0,
    });
  };

  // Todo filtro que rearme el conjunto de resultados tiene que volver a la primera
  // página. La paginación es del lado del servidor: pedir la página 3 de una búsqueda
  // que sólo tiene una devuelve `results: []` mientras `total` ya trae el conteo nuevo,
  // así que la tabla queda vacía aunque el contador muestre los resultados.
  const volverAPrimeraPagina = useCallback(
    () => setStateTable((estado) => ({ ...estado, currentPage: 0 })),
    [],
  );

  const handleFilterByName = (event) => {
    setStateTable({
      ...statesTable,
      filterName: event.target.value,
      currentPage: 0,
    });
  };

  const facturasFiltradas = useMemo(() => {
    // Estas propiedades tienen que cubrir al menos lo que busca el backend
    // (folio, nombre y rut del cliente, total): este filtro corre sobre lo que ya
    // devolvio la consulta, asi que cualquier campo que falte aca descarta filas
    // que el servidor si considero coincidencias.
    const propiedadesParaFiltrar = [
      "folio",
      "nombre",
      "refCliente",
      "valorPesos",
      "estadoFactura",
      "tipo",
    ];
    return applySortFilter(
      facturas.results,
      getComparator(statesTable.order, statesTable.orderBy),
      statesTable.filterName,
      propiedadesParaFiltrar,
    );
  }, [
    facturas.results,
    statesTable.filterName,
    statesTable.order,
    statesTable.orderBy,
  ]);

  const filasVacias =
    !loadingTable && statesTable.currentPage > 0
      ? Math.max(
          0,
          (1 + statesTable.currentPage) * statesTable.rowsPerPageOptions -
            facturas.results.length,
        )
      : 0;

  const seEncontroFactura = !loadingTable && facturas.results.length === 0;

  // .---------------- Alerta ------------------------
  const [showAlerta, setShowAlerta] = useState(false);
  const [alerta, setAlerta] = useState({
    mensaje: "error inesperado",
    color: "error",
  });

  const mostrarAlerta = (mensaje, color = "error") => {
    setAlerta({ mensaje, color });
    setShowAlerta(true);
  };

  const [selectedInvoice, setSelectedInvoice] = useState();

  //--------  Modal Factura  ------------------------------------
  const [selectFactura, setSelectFactura] = useState({
    estado: "",
    id: "",
    estadoCorreo: "",
    folio: "",
    refPlan: "",
    row: "",
  });

  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);

  const resetSelectFactura = () => {
    setSelectFactura({
      estado: "",
      id: "",
      estadoCorreo: "",
      folio: "",
      refPlan: "",
      row: "",
    });
  };

  //--------  Modal Correo  ------------------------------------

  const [openModalEC, setOpenModalEC] = useState(false);

  const handleClickEstadoCorreo = (row) => {
    setSelectedInvoice(row);
    setOpenModalEC(true);
  };

  const changeEstadoCorreo = async (estadoCorreo) => {
    let action;
    if (selectedInvoice.tipo === "PLAN") {
      actualizarEstadoCorreoPlanes({
        id: selectedInvoice.id,
        body: {
          empleadoEnviaCorreo: user.nombre + " " + user.apellidos,
          estadoCorreo: estadoCorreo,
        },
      }).unwrap();
    } else if (selectedInvoice.tipo === "TAREA") {
      actualizarEstadoCorreoTareas({
        id: selectedInvoice.id,
        body: {
          empleadoEnviaCorreo: user.nombre + " " + user.apellidos,
          estadoCorreo: estadoCorreo,
        },
      }).unwrap();
    } else {
      actualizarEstadoCorreoAfecta({
        id: selectedInvoice.id,
        body: {
          empleadoEnviaCorreo: user.nombre + " " + user.apellidos,
          estadoCorreo: estadoCorreo,
        },
      }).unwrap();
    }

    action
      .then(() => {
        setOpenModalEC(false);
        mostrarAlerta("Estado del correo actualizado con éxito.", "success");
        resetSelectFactura();
      })
      .catch(() => {
        mostrarAlerta("Error al cambiar estado del correo de la factura.");
      });
  };

  //--------  Modal Folio - Anulado  ------------------------------------

  const [openModalFA, setOpenModalFA] = useState(false);

  const submitFolioAnulada = async () => {
    let action;
    if (selectFactura.tipo === "PLAN") {
      action = actualizarEstadoFacturaPlanes({
        id: selectFactura.id,
        body: {
          folio: selectFactura.folio,
          estadoFactura: selectFactura.estado,
        },
      }).unwrap();
    } else if (selectFactura.tipo === "TAREA") {
      action = actualizarEstadoFacturaTareas({
        id: selectFactura.id,
        body: {
          folio: selectFactura.folio,
          estadoFactura: selectFactura.estado,
        },
      }).unwrap();
    } else {
      action = actualizarEstadoFacturaAfecta({
        id: selectFactura.id,
        body: {
          folio: selectFactura.folio,
          estadoFactura: selectFactura.estado,
        },
      }).unwrap();
    }

    action
      .then(() => {
        setOpenModalFA(false);
        mostrarAlerta("Factura anulada con éxito.", "success");
        resetSelectFactura();
      })
      .catch(() => {
        mostrarAlerta("Error al cambiar estado de la factura a 'ANULADA'.");
      });
  };

  //--------  Modal Folio  ------------------------------------

  const [openModalF, setOpenModalF] = useState(false);

  const handleClickFolio = (row) => {
    setSelectFactura({
      ...selectFactura,
      folio: row.folio,
      id: row.id,
      row,
    });
    setOpenModalF(true);
  };

  const changeFolio = async (folio) => {
    setSelectFactura({
      ...selectFactura,
      folio,
      id: selectFactura.id,
    });
  };

  const submitFolio = async () => {
    let error = false;

    if (selectFactura.tipo === "PLAN" || selectFactura.tipo === "AFECTA") {
      error = await actualizarFolioFactura({
        folio: selectFactura.folio,
        id: selectFactura.id,
      }).unwrap();
    } else {
      error = await actualizarFolioFacturaTarea({
        folio: selectFactura.folio,
        id: selectFactura.id,
      }).unwrap();
    }

    if (error === true) {
      setOpenModalF(false);
      recargarFacturas();
      mostrarAlerta("Folio de factura actualizado con éxito.", "success");
      resetSelectFactura();
    } else {
      mostrarAlerta("Error al cambiar Folio");
    }
  };

  //----------- Modal Ver ----------------------------------------
  const [openModalVF, setOpenModalVF] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc =
      statesTable.orderBy === property && statesTable.order === "asc";
    setStateTable({
      ...statesTable,
      order: isAsc ? "desc" : "asc",
      orderBy: property,
    });
  };

  const handleSucursalSelection = useCallback(
    (event, newValue) => {
      setFieldValue("filtro", newValue);
      setFieldValue("incluyeRemuneraciones", false);
      volverAPrimeraPagina();
    },
    [setFieldValue, volverAPrimeraPagina],
  );

  const handleOptionLabelDivision = useCallback((option) => option.label, []);

  const handleIsOptionEqualToValueDivision = useCallback(
    (option, value) => option.id === value.id,
    [],
  );

  const manejarExportacionExcel = async () => {
    setLoadingExport(true);

    const body = {
      sucursales:
        rolObtenido === "SUPER_ADMIN" || rolObtenido === "ADMIN"
          ? values.filtro.nombre === "TODAS" //Si selecciona todas las sucursales en el select, se pasan las sucursales del empleado para filtrar
            ? sucursalesEmpleado
            : values.filtro.nombre
          : sucursalObtenida,
      mesInicio: mesActual + 1 <= 9 ? `0${mesActual + 1}` : mesActual + 1,
      anioInicio: anioActual,
      mesFin: mesActual2 + 1 <= 9 ? `0${mesActual2 + 1}` : mesActual2 + 1,
      anioFin: anioActual2,
      incluyeRemuneraciones: values.incluyeRemuneraciones,
    };

    try {
      const { data: facturas } = await exportarFacturasExcel(body);

      const templatePath = "/static/plantillas/PLANTILLA_FACTURAS.xlsx";

      const fechaInicio = dayjs()
        .year(anioActual)
        .month(mesActual)
        .format("MMMM YYYY");
      const fechaFin = dayjs()
        .year(anioActual2)
        .month(mesActual2)
        .format("MMMM YYYY");

      const datosExcel = {
        ...facturas,
        fechaInicio,
        fechaFin,
        sucursal: values.filtro.nombre,
      };

      const workbook = await rellenarPlantilla(templatePath, datosExcel);

      await guardarArchivo(
        workbook,
        `Facturas desde ${fechaInicio} hasta ${fechaFin}.xlsx`,
      );
      setLoadingExport(false);
    } catch (error) {
      setLoadingExport(false);
      mostrarAlerta("Ocurrió un error desconocido al exportar facturas");
      handleError("manejarExportacionExcel", error);
    }
  };

  const openModalCambioSucursal = ({ id, antiguaSucursal, tipo }) => {
    setModalCambioSucursal(true);
    setDatosCambioSucursal({ id, antiguaSucursal, tipo });
  };

  /**
   * Maneja la anulación de una factura
   * Abre el modal de anulación con los datos de la factura
   */
  const handleAbrirModalAnular = (factura) => {
    // Validar permisos
    if (rolObtenido !== "ADMIN" && rolObtenido !== "SUPER_ADMIN") {
      enqueueSnackbar(
        "Solo usuarios ADMIN o SUPER_ADMIN pueden anular facturas",
        { variant: "error" },
      );
      return;
    }

    // Validar estado
    const estadosNoPermitidos = ["ANULADO", "INCOBRABLE", "CORRECCIÓN"];
    if (estadosNoPermitidos.includes(factura.estadoFactura)) {
      enqueueSnackbar(
        `No se puede anular una factura con estado ${factura.estadoFactura}`,
        { variant: "error" },
      );
      return;
    }

    setFacturaAAnular(factura);
    setModalAnularFactura(true);
  };

  /**
   * Ejecuta la anulación de la factura
   * Maneja el flujo de 2 pasos y las respuestas del backend
   */
  const handleAnularFactura = async (datos) => {
    try {
      const resultado = await anularFactura({
        id: facturaAAnular.id,
        tipo: facturaAAnular.tipo || "PLAN",
        motivoAnulacion: datos.motivoAnulacion,
        confirmarEliminacionAbonos: datos.confirmarEliminacionAbonos || false,
      }).unwrap();

      // Si requiere confirmación (tiene abonos), retornar los datos
      if (resultado.requiereConfirmacion) {
        return resultado;
      }

      // Anulación exitosa. El folio se lee con guarda: si el backend deja de mandar la nota
      // -como pasaba cuando la respuesta de confirmación salía con 200 y el schema del éxito
      // le borraba los campos-, el error que se veía era un "folio de undefined" que no decía
      // nada de lo que realmente había fallado.
      // Se da de baja en vez de eliminarlo definitivamente para no perder el registro de la operación
      const folioNota = resultado.notaCredito?.folio;
      const abonosEliminados = resultado.abonosEliminados;
      const detallePagos =
        abonosEliminados?.cantidad > 0
          ? ` Se dieron de baja ${abonosEliminados.cantidad} ${
              abonosEliminados.cantidad === 1 ? "pago" : "pagos"
            } por ${formatAsCLP(abonosEliminados.totalAbonado)}.`
          : "";

      enqueueSnackbar(
        (folioNota
          ? `Factura anulada correctamente. Nota de Crédito generada con folio: ${folioNota}`
          : "Factura anulada correctamente.") + detallePagos,
        {
          variant: "success",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
      );

      // Cerrar modal
      setModalAnularFactura(false);
      setFacturaAAnular(null);

      // Recargar facturas
      recargarFacturas();

      return resultado;
    } catch (error) {
      console.error("Error al anular factura:", error);

      // Mostrar error
      enqueueSnackbar(
        error?.data?.message || error?.message || "Ocurrió un error inesperado",
        { variant: "error" },
      );

      throw error;
    }
  };

  const handleCerrarModalAnular = () => {
    setModalAnularFactura(false);
    setFacturaAAnular(null);
  };

  /**
   * Abre el modal de corrección de monto
   * Valida permisos, estado y antigüedad de la factura
   * @param {Object} factura - Factura a corregir
   */
  const handleAbrirModalCorregir = (factura) => {
    // Validar permisos
    if (rolObtenido !== "ADMIN" && rolObtenido !== "SUPER_ADMIN") {
      enqueueSnackbar(
        "Solo usuarios ADMIN o SUPER_ADMIN pueden corregir montos",
        { variant: "error" },
      );
      return;
    }

    // Validar tipo de documento
    if (!TIPOS_CORREGIBLES.includes(factura.tipo)) {
      enqueueSnackbar(
        "La corrección de monto no está disponible para facturas afectas",
        { variant: "error" },
      );
      return;
    }

    // Validar estado
    const estadosNoPermitidos = ["ANULADO", "INCOBRABLE"];
    if (estadosNoPermitidos.includes(factura.estadoFactura)) {
      enqueueSnackbar(
        `No se puede corregir una factura con estado ${factura.estadoFactura}`,
        { variant: "error" },
      );
      return;
    }

    // Validar antigüedad (máximo 6 meses)
    const fechaFacturacion = moment(factura.fechaFacturacion, "YYYY/MM/DD");
    const mesesDiferencia = moment().diff(fechaFacturacion, "months");

    if (mesesDiferencia > 6) {
      enqueueSnackbar(
        `Solo se pueden corregir facturas de los últimos 6 meses. Esta factura tiene ${mesesDiferencia} meses de antigüedad.`,
        { variant: "error" },
      );
      return;
    }

    setFacturaACorregir(factura);
    setModalCorregirMonto(true);
  };

  /**
   * Ejecuta la corrección de monto de la factura
   * Llama al endpoint del backend, descarga el PDF automáticamente y maneja las respuestas
   * @param {Object} datos - Datos de la corrección (tipoCorreccion, montoDelta, motivoCorreccion)
   */
  const handleCorregirMonto = async (datos) => {
    try {
      const resultado = await corregirMonto({
        id: facturaACorregir.id,
        tipo: facturaACorregir.tipo || "PLAN",
        tipoCorreccion: datos.tipoCorreccion,
        montoDelta: datos.montoDelta,
        motivoCorreccion: datos.motivoCorreccion,
      }).unwrap();

      // Descargar PDF automáticamente
      if (resultado.documentoCorreccion?.pdf) {
        try {
          const { tipo, folio, pdf } = resultado.documentoCorreccion;

          // Generar nombre del archivo
          const tipoDocumento = tipo === "NC" ? "Nota_Credito" : "Nota_Debito";
          const nombreArchivo = `${tipoDocumento}_${folio}.pdf`;

          descargarPDFDesdeBase64(pdf, nombreArchivo, enqueueSnackbar);
        } catch (errorPDF) {
          console.error("Error al descargar PDF:", errorPDF);
        }
      }

      // Corrección exitosa
      const tipoDocumento = resultado.documentoCorreccion.tipo;
      const accion =
        datos.tipoCorreccion === "AUMENTO" ? "aumentado" : "reducido";

      enqueueSnackbar(
        `Monto ${accion} correctamente. ${tipoDocumento} generada con folio: ${resultado.documentoCorreccion.folio}`,
        {
          variant: "success",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
      );

      // Cerrar modal
      setModalCorregirMonto(false);
      setFacturaACorregir(null);

      // Recargar facturas
      recargarFacturas();
    } catch (error) {
      console.error("Error al corregir monto:", error);

      // Mostrar error
      enqueueSnackbar(
        error?.data?.message || error?.message || "Ocurrió un error inesperado",
        { variant: "error" },
      );
    }
  };

  /**
   * Cierra el modal de corrección y limpia el estado
   */
  const handleCerrarModalCorregir = () => {
    setModalCorregirMonto(false);
    setFacturaACorregir(null);
  };

  /**
   * Cuadra una factura con saldo menor al umbral configurado.
   * Crea un nuevo pago con metodoPago='CUADRE' y marca la factura como PAGADO.
   */
  const handleCuadrarFactura = async (factura) => {
    const montoFormateado = formatNumber(factura.deudaActual);

    const resultado = await AlertaModalV2({
      title: `¿Cuadrar factura?`,
      text: `Se cuadrará la diferencia de $${montoFormateado} en la factura ${factura.folio}`,
      confirmButtonText: "Sí, cuadrar",
      cancelButtonText: "Cancelar",
      icon: "warning",
    }).fire();

    if (!resultado?.isConfirmed) return;

    try {
      await cuadrarFactura({
        tipo: factura.tipo || "PLAN",
        idFactura: factura.id,
        folio: factura.folio,
        rolUsuario: rolObtenido,
      }).unwrap();

      enqueueSnackbar(`Factura ${factura.folio} cuadrada exitosamente.`, {
        variant: "success",
      });
      recargarFacturas();
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ||
          error?.message ||
          "Error al cuadrar la factura.",
        { variant: "error" },
      );
    }
  };

  /**
   * Descarga el PDF del documento de la propia fila por el proxy backend
   * (la apikey vive solo en el backend). Cada fila baja su propio DTE: la fila
   * de la factura baja la factura, la de la Nota de Crédito/Débito baja la NC/ND.
   * @param {Object} factura - Fila de factura a descargar
   */
  const handleDescargarPDF = async (factura) => {
    const tipo = tipoProxyDesdeFactura(factura.tipo);
    if (!tipo) {
      enqueueSnackbar(
        "No se pudo determinar el tipo de factura para descargar el PDF.",
        {
          variant: "error",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
      );
      return;
    }
    if (!factura.id) {
      enqueueSnackbar(
        "No se pudo identificar el documento para descargar el PDF.",
        {
          variant: "error",
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        },
      );
      return;
    }
    if (!factura.token) {
      enqueueSnackbar("Error, documento no encontrado", {
        variant: "error",
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
      });
      return;
    }
    setLoadingDescargar(true);
    try {
      await descargarPdfDteProxy({
        trigger: descargarPdfDte,
        tipo,
        id: factura.id,
        nombreArchivo: nombreArchivoDte(factura.tipoDte, factura.folio),
        enqueueSnackbar,
      });
    } finally {
      setLoadingDescargar(false);
    }
  };

  /**
   * Abre el menú de acciones para una factura
   * @param {Event} event - Evento del click
   * @param {Object} factura - Factura seleccionada
   */
  const handleAbrirMenu = (event, factura) => {
    setAnchorEl(event.currentTarget);
    setFacturaMenuSeleccionada(factura);
  };

  /**
   * Cierra el menú de acciones
   */
  const handleCerrarMenu = () => {
    setAnchorEl(null);
    setFacturaMenuSeleccionada(null);
  };

  if (tabIndex !== 0) return null;

  return (
    <>
      <Card>
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
          <Grid
            container
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
            marginTop={1}
          >
            <Grid
              item
              xs={12}
              md={
                rolObtenido === "ADMIN" || rolObtenido === "SUPER_ADMIN"
                  ? 3
                  : 12
              }
              lg={
                rolObtenido === "ADMIN" || rolObtenido === "SUPER_ADMIN"
                  ? 3
                  : 12
              }
            >
              <TablaToolbar
                filterName={statesTable.filterName}
                onFilterName={handleFilterByName}
              />
            </Grid>

            {(rolObtenido === "SUPER_ADMIN" || rolObtenido === "ADMIN") && (
              <AutoCompleteField
                sx={{
                  marginRight: { md: 0, xs: 3, sm: 3 },
                  marginLeft: { md: 0, xs: 3, sm: 3 },
                }}
                disableClearable={true}
                id="autocomplete-filtro-facturas-sucursal"
                label="Sucursal"
                value={values.filtro}
                xs={12}
                md={3}
                lg={3}
                handleSucursalSelection={handleSucursalSelection}
                options={opcionesFiltro}
                touched={touched.filtro}
                error={errors.filtro}
                getOptionLabel={handleOptionLabelDivision}
                isOptionEqualToValue={handleIsOptionEqualToValueDivision}
                typeRenderInput="normal"
              />
            )}

            <Grid item lg={4} xs={12} md={4}>
              <Container sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ExportarAExcel
                  nombreBoton="facturas"
                  onClick={manejarExportacionExcel}
                  loadingExport={loadingExport}
                />
                {values.filtro.nombre !== "REMUNERACIONES" &&
                  values.filtro.nombre !== "TODAS" && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          size="small"
                          checked={values.incluyeRemuneraciones}
                          color="primary"
                          onChange={(e) =>
                            formik.setFieldValue(
                              "incluyeRemuneraciones",
                              e.target.checked,
                            )
                          }
                        />
                      }
                      label="Incluir Remuneraciones"
                    />
                  )}
              </Container>
            </Grid>
          </Grid>
        </LocalizationProvider>
        <Divider sx={{ padding: 1 }} />
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
          <Grid
            container
            style={{ padding: "2rem 1.5rem 0rem 1.5rem" }}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              <Grid container spacing={2} justifyContent="flex-start">
                <Grid item xs={12} md={5} style={{ marginRight: "10px" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      MES INICIO
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={mesActual + 1}
                      label="MES"
                      onChange={(event) => {
                        setMesActual(event.target.value - 1);
                        volverAPrimeraPagina();
                      }}
                    >
                      <MenuItem value={1}>ENERO</MenuItem>
                      <MenuItem value={2}>FEBRERO</MenuItem>
                      <MenuItem value={3}>MARZO</MenuItem>
                      <MenuItem value={4}>ABRIL</MenuItem>
                      <MenuItem value={5}>MAYO</MenuItem>
                      <MenuItem value={6}>JUNIO</MenuItem>
                      <MenuItem value={7}>JULIO</MenuItem>
                      <MenuItem value={8}>AGOSTO</MenuItem>
                      <MenuItem value={9}>SEPTIEMBRE</MenuItem>
                      <MenuItem value={10}>OCTUBRE</MenuItem>
                      <MenuItem value={11}>NOVIEMBRE</MenuItem>
                      <MenuItem value={12}>DICIEMBRE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      AÑO INICIO
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={anioActual}
                      label="AÑO"
                      onChange={(event) => {
                        setAnioActual(event.target.value);
                        volverAPrimeraPagina();
                      }}
                    >
                      {anios.map((elemento, idx) => {
                        return (
                          <MenuItem key={"anios_" + idx} value={elemento}>
                            {elemento}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item xs={12} md={5} style={{ marginRight: "10px" }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      MES FIN
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={mesActual2 + 1}
                      label="MES"
                      onChange={(event) => {
                        setMesActual2(event.target.value - 1);
                        volverAPrimeraPagina();
                      }}
                    >
                      <MenuItem value={1}>ENERO</MenuItem>
                      <MenuItem value={2}>FEBRERO</MenuItem>
                      <MenuItem value={3}>MARZO</MenuItem>
                      <MenuItem value={4}>ABRIL</MenuItem>
                      <MenuItem value={5}>MAYO</MenuItem>
                      <MenuItem value={6}>JUNIO</MenuItem>
                      <MenuItem value={7}>JULIO</MenuItem>
                      <MenuItem value={8}>AGOSTO</MenuItem>
                      <MenuItem value={9}>SEPTIEMBRE</MenuItem>
                      <MenuItem value={10}>OCTUBRE</MenuItem>
                      <MenuItem value={11}>NOVIEMBRE</MenuItem>
                      <MenuItem value={12}>DICIEMBRE</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={5}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      AÑO FIN
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={anioActual2}
                      label="AÑO"
                      onChange={(event) => {
                        setAnioActual2(event.target.value);
                        volverAPrimeraPagina();
                      }}
                    >
                      {anios.map((elemento, idx) => {
                        return (
                          <MenuItem key={"anios2_" + idx} value={elemento}>
                            {elemento}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </LocalizationProvider>
        <TableContainer>
          {!isFetchingSucursales ? (
            <Scrollbar>
              <Table stickyHeader>
                <TablaHead
                  order={statesTable.order}
                  orderBy={statesTable.orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={!loadingTable && facturas.results.length}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {facturasFiltradas.map((row) => {
                    const {
                      id,
                      refCliente,
                      nombre,
                      folio,
                      valorPesos,
                      fecha,
                      sucursal,
                      fechaFacturacion,
                      fechaCorreo,
                      estadoCorreo,
                      estadoFactura,
                      fechaPago,
                      detalleFactura,
                      telefonoCliente,
                      tipo,
                      tipoDte,
                      deudaActual,
                    } = row;

                    const diasRetraso =
                      estadoFactura.toLowerCase() !== "pagado" &&
                      estadoFactura.toLowerCase() !== "anulado" &&
                      estadoFactura.toLowerCase() !== "incobrable"
                        ? calcularDiasRetraso(fechaFacturacion)
                        : 0;

                    const periodo =
                      sucursal && sucursal.toLowerCase() === "remuneraciones"
                        ? capitalizarPrimeraLetra(
                            formatearFecha(ajustarFecha(fecha, -1), "MMMM"),
                          )
                        : capitalizarPrimeraLetra(
                            formatearFecha(fecha, "MMMM"),
                          );

                    const esCuadrable =
                      estadoFactura === "ABONO" &&
                      deudaActual != null &&
                      deudaActual > 0 &&
                      deudaActual <=
                        APP_CONFIG.CUADRE_FACTURA.MONTO_MAXIMO_DIFERENCIA;

                    return (
                      <TableRow
                        hover
                        key={id}
                        style={
                          esCuadrable
                            ? { backgroundColor: "rgba(255, 193, 7, 0.12)" }
                            : undefined
                        }
                      >
                        <TableCell align="left">
                          <Typography variant="subtitle2" noWrap>
                            {refCliente
                              ? formatRut(refCliente, RutFormat.DOTS_DASH)
                              : "Cliente no encontrado"}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle2">
                            {nombre ? nombre : "S/I"}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {telefonoCliente ? telefonoCliente : "S/I"}
                        </TableCell>
                        <TableCell
                          align="left"
                          //onClick={() => handleClickFolio(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Button
                            color="primary"
                            disabled={
                              estadoFactura !== "NO FACTURADO" ||
                              estadoCorreo === "ENVIADO"
                            }
                            onClick={() => handleClickFolio(row)}
                          >
                            {folio ? folio : 0}
                          </Button>
                        </TableCell>
                        <TableCell align="left">
                          <TipoDocumentoChip tipoDte={tipoDte} />
                        </TableCell>
                        <TableCell align="left">
                          {detalleFactura
                            ? decodeHtmlEntities(detalleFactura, document)
                            : "S/I"}
                        </TableCell>
                        <TableCell align="left">
                          {formatNumber(valorPesos)}
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle2" noWrap>
                            {periodo}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {fechaFacturacion === ""
                            ? fechaFacturacion
                            : moment(fechaFacturacion, "YYYY/MM/DD").format(
                                "DD/MM/YYYY",
                              )}
                        </TableCell>
                        <TableCell align="left">
                          {fechaCorreo === ""
                            ? "Sin enviar"
                            : moment(fechaCorreo, "YYYY/MM/DD").format(
                                "DD/MM/YYYY",
                              )}
                        </TableCell>
                        <TableCell align="left">
                          <Button
                            disabled={
                              estadoFactura !== "FACTURADO" ||
                              folio === "" ||
                              estadoCorreo === "ENVIADO"
                            }
                            onClick={() => handleClickEstadoCorreo(row)}
                          >
                            <Label
                              variant="ghost"
                              color={
                                (estadoCorreo === "ENVIADO" && "success") ||
                                "error"
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {capitalizarPrimeraLetra(
                                estadoCorreo === ""
                                  ? "No enviado"
                                  : estadoCorreo,
                              )}
                            </Label>
                          </Button>
                        </TableCell>
                        <TableCell align="left">
                          <Label
                            variant="ghost"
                            color={
                              estadoFactura === "FACTURADO"
                                ? "success"
                                : estadoFactura === "PAGADO"
                                  ? "info"
                                  : "error"
                            }
                          >
                            {capitalizarPrimeraLetra(estadoFactura)}
                          </Label>
                        </TableCell>

                        <TableCell align="left">
                          {fechaPago ? fechaPago : ""}
                        </TableCell>
                        <TableCell align="left">
                          <Label
                            variant="ghost"
                            color={
                              (tipo === "PLAN" && "success") ||
                              (tipo === "TAREA" && "info") ||
                              "error"
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {capitalizarPrimeraLetra(tipo)}
                          </Label>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="subtitle2" noWrap>
                            {sucursal}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          {diasRetraso > 0 ? (
                            <Chip
                              variant="outlined"
                              icon={
                                <Iconify width={14} icon={warningOutlined} />
                              }
                              label={`${diasRetraso} días`}
                              color="error"
                              size="small"
                            />
                          ) : (
                            <Chip
                              variant="outlined"
                              icon={
                                <Iconify
                                  width={14}
                                  icon={checkCircleOutlined}
                                />
                              }
                              label="Sin retraso"
                              color="success"
                              size="small"
                            />
                          )}
                        </TableCell>
                        {/* COLUMNA DE ACCIONES */}
                        <TableCell align="right">
                          <IconButton
                            size="small"
                            onClick={(e) => handleAbrirMenu(e, row)}
                          >
                            <MoreVertIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {filasVacias > 0 && (
                    <TableRow style={{ height: 53 }}>
                      <TableCell colSpan={15} />
                    </TableRow>
                  )}
                </TableBody>

                {seEncontroFactura && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={15} sx={{ py: 3 }}>
                        <SearchNotFound
                          searchFilter={true}
                          searchQuery={statesTable.filterName}
                        />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </Scrollbar>
          ) : (
            <Skeleton variant="rectangular" width="100%" height="500px" />
          )}
        </TableContainer>
        {/* ==================== MENÚ DE ACCIONES ==================== */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCerrarMenu}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {facturaMenuSeleccionada && (
            <>
              {/* ===== VER PAGOS (solo si NO está anulada) ===== */}
              {facturaMenuSeleccionada.estadoFactura !== "ANULADO" && (
                <MenuItem
                  onClick={() => {
                    setFacturaSeleccionada(facturaMenuSeleccionada);
                    setOpenModalVF(true);
                    handleCerrarMenu();
                  }}
                >
                  <ListItemIcon>
                    <VisibilityIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary="Ver pagos" />
                </MenuItem>
              )}

              {/* ===== PAGAR (solo si NO está anulada y permisos) ===== */}
              {facturaMenuSeleccionada.estadoFactura !== "ANULADO" &&
                rolObtenido !== "EMPLEADO" &&
                rolObtenido !== "GERENTE_SUCURSAL" && (
                  <MenuItem
                    onClick={() => {
                      setFacturaSeleccionada(facturaMenuSeleccionada);
                      setMostrarPagoFactura(true);
                      handleCerrarMenu();
                    }}
                    disabled={
                      facturaMenuSeleccionada.estadoFactura === "PAGADO" ||
                      facturaMenuSeleccionada.estadoFactura === "INCOBRABLE"
                    }
                  >
                    <ListItemIcon>
                      <PaidIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Pagar" />
                  </MenuItem>
                )}

              {/* ===== DESCARGAR PDF ===== */}
              <MenuItem
                onClick={() => {
                  handleDescargarPDF(facturaMenuSeleccionada);
                  handleCerrarMenu();
                }}
                disabled={loadingDescargar}
              >
                <ListItemIcon>
                  <DownloadIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    loadingDescargar ? "Descargando..." : "Descargar PDF"
                  }
                />
              </MenuItem>

              <Divider />

              {/* ===== ACCIONES ADMIN/SUPER_ADMIN ===== */}
              {(rolObtenido === "ADMIN" || rolObtenido === "SUPER_ADMIN") && (
                <>
                  {/* CAMBIAR SUCURSAL */}
                  <MenuItem
                    onClick={() => {
                      openModalCambioSucursal({
                        id: facturaMenuSeleccionada.id,
                        tipo: facturaMenuSeleccionada.tipo || "PLAN",
                        antiguaSucursal: facturaMenuSeleccionada.sucursal,
                      });
                      handleCerrarMenu();
                    }}
                  >
                    <ListItemIcon>
                      <SwapHoriz fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Cambiar sucursal" />
                  </MenuItem>

                  {/* CORREGIR MONTO - Solo si es válida.
                      PAGADO sí se corrige: el backend recalcula el estado contra los pagos
                      vigentes, así que un aumento sobre una factura cobrada la devuelve a
                      ABONO con el saldo de la diferencia. Esconderla aquí dejaba fuera de la
                      interfaz el caso que la corrección tiene que resolver. */}
                  {TIPOS_CORREGIBLES.includes(facturaMenuSeleccionada.tipo) &&
                    !["ANULADO", "INCOBRABLE"].includes(
                      facturaMenuSeleccionada.estadoFactura,
                    ) &&
                    moment().diff(
                      moment(
                        facturaMenuSeleccionada.fechaFacturacion,
                        "YYYY/MM/DD",
                      ),
                      "months",
                    ) <= 6 && (
                      <MenuItem
                        onClick={() => {
                          handleAbrirModalCorregir(facturaMenuSeleccionada);
                          handleCerrarMenu();
                        }}
                        disabled={isLoadingCorregir}
                      >
                        <ListItemIcon>
                          <AttachMoneyIcon fontSize="small" color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Corregir monto"
                          primaryTypographyProps={{
                            style: { color: "#1976d2" },
                          }}
                        />
                      </MenuItem>
                    )}

                  {/* CUADRAR DIFERENCIA - Solo si está en ABONO con deuda mínima */}
                  {facturaMenuSeleccionada.estadoFactura === "ABONO" &&
                    facturaMenuSeleccionada.deudaActual != null &&
                    facturaMenuSeleccionada.deudaActual > 0 &&
                    facturaMenuSeleccionada.deudaActual <=
                      APP_CONFIG.CUADRE_FACTURA.MONTO_MAXIMO_DIFERENCIA && (
                      <MenuItem
                        onClick={() => {
                          handleCuadrarFactura(facturaMenuSeleccionada);
                          handleCerrarMenu();
                        }}
                        disabled={isLoadingCuadre}
                      >
                        <ListItemIcon>
                          <MonetizationOnIcon
                            fontSize="small"
                            style={{ color: "#f59e0b" }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Cuadrar diferencia"
                          primaryTypographyProps={{
                            style: { color: "#b45309" },
                          }}
                        />
                      </MenuItem>
                    )}

                  {/* ANULAR FACTURA - Solo si no está anulada */}
                  {!["ANULADO", "INCOBRABLE", "CORRECCIÓN"].includes(
                    facturaMenuSeleccionada.estadoFactura,
                  ) && (
                    <>
                      <Divider />
                      <MenuItem
                        onClick={() => {
                          handleAbrirModalAnular(facturaMenuSeleccionada);
                          handleCerrarMenu();
                        }}
                        disabled={isLoadingAnular}
                        sx={{ color: "error.main" }}
                      >
                        <ListItemIcon>
                          <CancelIcon fontSize="small" color="error" />
                        </ListItemIcon>
                        <ListItemText primary="Anular factura" />
                      </MenuItem>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </Menu>

        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <ThemeProvider
            theme={(outerTheme) =>
              createTheme(outerTheme, locales[statesTable.locale])
            }
          >
            <CustomTablePagination
              count={!loadingTable ? facturas.total : 0}
              rowsPerPage={statesTable.rowsPerPageOptions}
              page={statesTable.currentPage}
              colSpan={16}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[10, 15, 50]}
            />
          </ThemeProvider>
        </Box>
      </Card>

      {selectedInvoice && (
        <ModalChangeState
          object={selectedInvoice}
          onSubmit={changeEstadoCorreo}
          title="Cambiar estado correo factura"
          state="estadoCorreo"
          onClose={() => setOpenModalEC(false)}
          states={["NO ENVIADO", "ENVIADO"]}
          disabled={optionsEstadoCorreoFactura[selectedInvoice.estadoCorreo]}
          open={openModalEC}
        />
      )}

      <ModalForm
        open={openModalF}
        setOpen={setOpenModalF}
        value={selectFactura.folio}
        title="Ingrese Folio"
        content=""
        label="Folio"
        type="String"
        onSubmit={submitFolio}
        setUpdate={changeFolio}
      />

      <ModalForm
        open={openModalFA}
        setOpen={setOpenModalFA}
        value={selectFactura.folio}
        title="Ingrese Nuevo Folio"
        content=""
        label="Folio"
        type="String"
        onSubmit={submitFolioAnulada}
        setUpdate={changeFolio}
      />

      {openModalVF && facturaSeleccionada && (
        <ModalVerFactura
          open={openModalVF}
          setOpen={setOpenModalVF}
          factura={facturaSeleccionada}
          onRefetch={recargarFacturas}
        />
      )}
      {mostrarPagoFactura && (
        <PagosFacturaPlanesDialog
          open={mostrarPagoFactura}
          setOpen={setMostrarPagoFactura}
          factura={facturaSeleccionada}
          recargarFacturas={recargarFacturas}
        />
      )}
      <Alerta
        showAlert={showAlerta}
        setShowAlert={setShowAlerta}
        message={alerta.mensaje}
        color={alerta.color}
      />
      {modalCambioSucursal && (
        <ModalCambioSucursal
          data={datosCambioSucursal}
          isOpen={modalCambioSucursal}
          setOpen={setModalCambioSucursal}
          sucursales={sucursalesEmpleado}
        />
      )}

      {modalAnularFactura && (
        <ModalAnularFactura
          open={modalAnularFactura}
          onClose={handleCerrarModalAnular}
          factura={facturaAAnular}
          onAnular={handleAnularFactura}
          isLoading={isLoadingAnular}
        />
      )}

      {modalCorregirMonto && (
        <ModalCorregirMonto
          open={modalCorregirMonto}
          onClose={handleCerrarModalCorregir}
          factura={facturaACorregir}
          onCorregir={handleCorregirMonto}
          isLoading={isLoadingCorregir}
        />
      )}
    </>
  );
}

// const optionsEstadoFactura = {
//   "NO FACTURADO": [true, false, false],
//   FACTURADO: [true, true, false],
//   ANULADO: [true, true, true],
//   default: [false, false, false],
// };

const rellenar = (
  worksheet,
  datosTabla,
  tituloTabla,
  filaInicial,
  columnas,
) => {
  try {
    const {
      HEADER_TITLE,
      TITLE_FONT_STYLE,
      HEADER_FILL,
      HEADER_FONT_STYLE,
      DATA_FONT_STYLE,
    } = CONSTANTES_EXCEL;

    const primeraColumna = columnas[0];
    const ultimaColumna = columnas[columnas.length - 1];

    worksheet.getCell(`${primeraColumna.id}${filaInicial - 1}`).value =
      tituloTabla;
    worksheet.mergeCells(
      `${primeraColumna.id}${filaInicial - 1}`,
      `${ultimaColumna.id}${filaInicial - 1}`,
    );
    worksheet.getCell(`${primeraColumna.id}${filaInicial - 1}`).alignment = {
      vertical: "middle",
      horizontal: "center",
    };
    worksheet.getCell(`${primeraColumna.id}${filaInicial - 1}`).fill =
      HEADER_TITLE;
    worksheet.getCell(`${primeraColumna.id}${filaInicial - 1}`).font =
      TITLE_FONT_STYLE;

    columnas.forEach((columna) => {
      worksheet.getCell(`${columna.id}${filaInicial}`).value = columna.titulo;
      worksheet.getCell(`${columna.id}${filaInicial}`).fill = HEADER_FILL;
      worksheet.getCell(`${columna.id}${filaInicial}`).font = HEADER_FONT_STYLE;
      worksheet.getCell(`${columna.id}${filaInicial}`).alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    datosTabla.forEach((dato, index) => {
      const rowIndex = filaInicial + 1 + index;
      columnas.forEach((columna) => {
        const valor = dato[columna.propiedad];
        const cell = worksheet.getCell(`${columna.id}${rowIndex}`);
        cell.font = DATA_FONT_STYLE;

        // Aplicar formato numérico si el valor es un número
        if (!isNaN(valor) && columna.propiedad !== "diasRetraso") {
          cell.value = valor;
          cell.numFmt = `$#,##0`;
        }

        if (columna.propiedad === "refCliente") {
          const rut = formatRut(valor, RutFormat.DOTS_DASH);
          cell.value = rut;
          cell.numFmt = "@"; // Se mantiene formato string en Excel
        } else if (columna.propiedad === "diasRetraso" && valor > 0) {
          // Cambiar el color del texto si el valor de dias retraso es mayor que 0
          cell.font = {
            ...DATA_FONT_STYLE,
            color: { argb: "FFFF0000" },
          };
          cell.value = valor;
          cell.numFmt = `#,##0`;
        } else if (columna.propiedad === "detallePagos") {
          cell.value = valor;
          cell.alignment = {
            vertical: "top",
            horizontal: "left",
            wrapText: true,
          };
        } else {
          cell.value = valor;
        }

        if (columna.propiedad !== "detallePagos") {
          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
          };
        }
      });
    });

    datosTabla.forEach((dato, index) => {
      const rowIndex = filaInicial + 1 + index;

      // Si la factura tiene detalle de pagos, ajustar el alto de la fila
      if (dato.detallePagos && dato.detallePagos.includes("\n")) {
        const cantidadLineas =
          (dato.detallePagos.match(/\n/g) || []).length + 1;
        const altoLinea = 15; // Altura aproximada por línea en Excel
        worksheet.getRow(rowIndex).height = cantidadLineas * altoLinea;
      }
    });

    worksheet.columns.forEach((column, columnIndex) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const text = cell.text || "";
        maxLength = Math.max(maxLength, text.length);
      });
      column.width = maxLength + 7;
    });
  } catch (error) {
    handleError("rellenar", error);
  }
};

const rellenarTabla = (worksheet, datos, tituloTabla, tipo) => {
  try {
    let columnas = [
      { id: "A", titulo: "Cliente", propiedad: "nombre" },
      { id: "B", titulo: "RUT cliente", propiedad: "refCliente" },
      { id: "C", titulo: "Sucursal", propiedad: "sucursal" },
      { id: "D", titulo: "Tipo factura", propiedad: "tipo" },
      { id: "E", titulo: "Folio factura", propiedad: "folio" },
      { id: "F", titulo: "Glosa", propiedad: "detalleFactura" },
      { id: "G", titulo: "Estado factura", propiedad: "estadoFactura" },
      { id: "H", titulo: "Referencia folio", propiedad: "folioRef" },
      { id: "I", titulo: "Precio factura", propiedad: "valorPesos" },
      { id: "J", titulo: "Abono factura", propiedad: "abono" },
      { id: "K", titulo: "Deuda", propiedad: "deuda" },
      { id: "L", titulo: "Fecha facturación", propiedad: "fecha_facturacion" },
      { id: "M", titulo: "Fecha pago", propiedad: "fechaPago" },
      { id: "N", titulo: "Detalle de pagos", propiedad: "detallePagos" },
      { id: "O", titulo: "Días retraso", propiedad: "diasRetraso" },
      { id: "P", titulo: "Empleado", propiedad: "empleado" },
    ];
    // if (tipo === "TAREA") {
    //   const nuevaColumna = {
    //     id: "N",
    //     titulo: "Empleado",
    //     propiedad: "empleado",
    //   };
    //   columnas.push(nuevaColumna);
    // }

    const filaInicialTabla = 8;

    rellenar(worksheet, datos, tituloTabla, filaInicialTabla, columnas);
  } catch (error) {
    handleError("rellenarTabla", error);
  }
};

const cargarPlantilla = async (templatePath) => {
  const workbook = new ExcelJS.Workbook();
  const templateBuffer = await fetch(templatePath).then((response) =>
    response.arrayBuffer(),
  );
  await workbook.xlsx.load(templateBuffer);
  return workbook;
};

const actualizarHojaFacturas = (
  workbook,
  facturas,
  nombreHoja,
  fechaInicio,
  fechaFin,
  sucursal,
) => {
  const worksheet = workbook.getWorksheet(nombreHoja);
  if (facturas.length === 0) {
    worksheet.destroy();
    return;
  }
  worksheet.name = nombreHoja;
  colocarEncabezados(worksheet, fechaInicio, fechaFin, sucursal);
  rellenarTabla(
    worksheet,
    facturas,
    nombreHoja,
    nombreHoja === "Facturas de Tareas" ? "TAREA" : "PLAN",
  );
  aplicarBordeUltimaFila(worksheet, 0, 15);
};

const colocarEncabezados = (worksheet, fechaInicio, fechaFin, sucursal) => {
  worksheet.eachRow({ includeEmpty: true }, (row) => {
    row.eachCell((cell) => {
      if (cell.value && typeof cell.value === "string") {
        cell.value = cell.value
          .replace(/"FECHAINICIO"/g, fechaInicio.toUpperCase())
          .replace(/"FECHATERMINO"/g, fechaFin.toUpperCase())
          .replace(/"SUCURSAL"/g, sucursal);
      }
    });
  });
};

const rellenarPlantilla = async (templatePath, datos) => {
  try {
    // Crear un nuevo objeto Workbook de ExcelJS junto a su plantilla
    const workbook = await cargarPlantilla(templatePath);
    // Habilitar el cálculo automático en la hoja
    activarCalculoAutomatico(workbook);

    const { facturas, fechaInicio, fechaFin, sucursal } = datos;

    actualizarHojaFacturas(
      workbook,
      facturas,
      "Facturas",
      fechaInicio,
      fechaFin,
      sucursal,
    );

    workbook.views = {
      activeTab: 0,
    };
    return workbook;
  } catch (error) {
    handleError("rellenarPlantilla", error);
  }
};

const optionsEstadoCorreoFactura = {
  "NO ENVIADO": [true, false],
  ENVIADO: [true, true],
  default: [false, false],
};

const CONSTANTES_EXCEL = {
  HEADER_FONT_STYLE: {
    name: "Arial Nova Cond",
    size: 12,
    bold: true,
    color: { argb: "44546A" },
  },
  TITLE_FONT_STYLE: {
    name: "Arial Nova Cond",
    size: 12,
    bold: true,
    color: { argb: "FFFFFF" },
  },
  DATA_FONT_STYLE: {
    name: "Arial Nova Cond",
    size: 12,
  },
  HEADER_FILL: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "ED7D31" },
  },
  HEADER_TITLE: {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "D9D9D9" },
  },
};
